<form class="form-grid" [formGroup]="form" (ngSubmit)="save()">
    <div class="form-field">
        <label for="select-measure-year" class="form-field__label form-field__label--required">{{
            'components.settingList.period' | translate
        }}</label>
        <p-select inputId="select-measure-year" [options]="availableYears" formControlName="year" appendTo="body" />
        @if (form.get('year')?.invalid && form.get('year')?.touched) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>
    <div class="form-field">
        <label for="select-measure-entity" class="form-field__label form-field__label--required">{{
            'components.settingList.entities' | translate
        }}</label>
        <p-select
            inputId="select-measure-entity"
            [options]="entities"
            optionLabel="name"
            formControlName="entity"
            appendTo="body" />
        @if (form.get('entity')?.invalid && form.get('entity')?.touched) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>
    <div class="form-actions">
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="close()" />
        <p-button type="submit" [label]="'components.settingsForm.button.settings' | translate" />
    </div>
</form>
